const translations = {
  "en": {
    "Any unused time on your current plan will be added to the end of your new plan.": "Any unused time on your current plan will be added to the end of your new plan.",
    "Cancel": "Cancel",
    "Close": "Close",
    "Confirm upgrade": "Confirm upgrade",
    "Update payment method": "Update payment method",
    "Upgrade to %{plan}": "Upgrade to %{plan}",
    "You'll be charged %{price} today with your saved payment method. Your new monthly billing cycle starts today.": "You'll be charged %{price} today with your saved payment method. Your new monthly billing cycle starts today.",
    "You'll be charged %{price} today with your saved payment method. Your new weekly billing cycle starts today.": "You'll be charged %{price} today with your saved payment method. Your new weekly billing cycle starts today.",
    "You'll be charged %{price} today with your saved payment method. Your new yearly billing cycle starts today.": "You'll be charged %{price} today with your saved payment method. Your new yearly billing cycle starts today.",
    "Your card was declined. Update your payment method, then try upgrading again.": "Your card was declined. Update your payment method, then try upgrading again."
  },
  "zh-tw": {
    "Any unused time on your current plan will be added to the end of your new plan.": "您目前方案未使用的時間，將加至您的新方案末尾。",
    "Cancel": "取消",
    "Close": "關閉",
    "Confirm upgrade": "確認升級",
    "Update payment method": "更新付款方式",
    "Upgrade to %{plan}": "升級至 %{plan}",
    "You'll be charged %{price} today with your saved payment method. Your new monthly billing cycle starts today.": "今日將使用您已儲存的付款方式，為您收取 %{price}。您的新每月計費週期自今日開始。",
    "You'll be charged %{price} today with your saved payment method. Your new weekly billing cycle starts today.": "今日將以您已儲存的付款方式扣款 %{price}。您的新每週計費週期自今日開始。",
    "You'll be charged %{price} today with your saved payment method. Your new yearly billing cycle starts today.": "今日將透過您儲存的付款方式扣款 %{price}。您的新年度計費週期自今日開始。",
    "Your card was declined. Update your payment method, then try upgrading again.": "您的卡片已遭拒。更新您的付款方式，然後再次嘗試升級。"
  }
};

export default translations;
